import React from 'react';
import ReactDOM from 'react-dom/client';

// Material UI is designed to use the Roboto font by default.
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Playfair Display — the display serif used for the "hero" numbers on the report dashboards.
import '@fontsource/playfair-display/700.css';
import '@fontsource/playfair-display/800.css';

import "./index.css"

import { App } from './app/App';


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);



root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);


